import THsInfoModal from "./THsInfoModal";

export default THsInfoModal;
